import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=2c65c082&"
import script from "./ResultCard.vue?vue&type=script&lang=ts&"
export * from "./ResultCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResultCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports